/* Duck Commander motion runtime (Plan 2)
   -----------------------------------------------------------------------------
   Opt-in via data attributes:
     - data-dc-reveal="" | "fade" | "from-left" | "from-right"
         Fades / slides the element into place when ~15% visible.
     - data-dc-parallax="0.2"
         Element translates vertically at (speed * scroll delta) while in view.
         0.2 = subtle, 0.5 = strong. Positive values move up as you scroll down.
     - data-dc-sticky-stack
         Sets `position: sticky` with a sensible top offset.
   Respects prefers-reduced-motion automatically. */

(function () {
  if (typeof window === 'undefined') return;

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('[data-dc-reveal]');
    if (!els.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    els.forEach(function (el) { observer.observe(el); });

    function revealIfAlreadyOnScreen() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (el) {
        if (el.classList.contains('is-revealed')) return;
        var rect = el.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < vh && rect.width > 0 && rect.height > 0) {
          el.classList.add('is-revealed');
        }
      });
    }

    // IntersectionObserver + layout can miss the first paint — run twice.
    requestAnimationFrame(revealIfAlreadyOnScreen);
    setTimeout(revealIfAlreadyOnScreen, 150);
  }

  function initParallax() {
    if (prefersReducedMotion) return;

    var els = document.querySelectorAll('[data-dc-parallax]');
    if (!els.length) return;

    var ticking = false;

    function apply() {
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewport) return;
        var speed = parseFloat(el.getAttribute('data-dc-parallax')) || 0.2;
        var middle = rect.top + rect.height / 2;
        var delta = (viewport / 2 - middle) * speed;
        el.style.transform = 'translate3d(0,' + delta.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(apply);
        ticking = true;
      }
    }

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function init() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
